import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { EditAssumptionsHeader, EditAssumptionsContent } from './components';

interface EditAssumptionsPageProps {
  clientId: string;
}

export function EditAssumptionsPage(_props: EditAssumptionsPageProps) {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <EditAssumptionsHeader onBack={handleBack} />
      <div className="mx-auto w-full max-w-4xl flex-1 px-4 py-6 sm:px-4 sm:py-8">
        <EditAssumptionsContent />
      </div>
    </div>
  );
}
